import StandaloneStep from './StandaloneStep';

export default StandaloneStep;
